import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";

// استایل‌ها
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.rtl.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/js/bootstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import "./index.css";
import "./output.css";

// Redux
import { Provider } from "react-redux";
import mainStore from "./stores/Redux/MainStore";

// Auth Context
import { AuthProvider } from "./guard/AuthContext";
import { UserSessionProvider } from "./stores/Context/UserSessionContext";
// React Query
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import queryClient from "./lib/queryClient";
// ساخت کلاینت
//const queryClient = new QueryClient();

const helmetContext = {};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <HelmetProvider context={helmetContext}>
      <Provider store={mainStore}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            {/* <UserSessionProvider> */}
              <App />
            {/* </UserSessionProvider> */}

            <ReactQueryDevtools initialIsOpen={false} />
          </AuthProvider>
        </QueryClientProvider>
      </Provider>
    </HelmetProvider>
  </StrictMode>
);

reportWebVitals();
